export default __webpack_public_path__ + "static/media/may-2021-international.46f0af33.csv";